import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { WEB_REPORTS_URL, SALES_REPORTS_URL } from 'config/constants';
import { authorize } from 'utils/auth';

import { FormattedMessage } from 'ui/i18n';

import './MainNav.scss';

export default class MainNav extends Component {
	render() {
		return (
			<div className="container-fluid MainNav">
				<div className="row">
					<div className="col-md-8 col-sm-8 col-xs-8">
						<NavLink
							className="MainNav-item"
							to="/"
							exact
							activeClassName="active"
						>
							<FormattedMessage id="navigation.home" />
						</NavLink>

						{authorize(
							['GetOrderHistory'],
							<NavLink
								to="/view-order-history"
								className="MainNav-item"
								activeClassName="active"
							>
								<FormattedMessage id="navigation.orderHistory" />
							</NavLink>
						)}
						{authorize(
							['GetOrderStatus'],
							<Link
								className="MainNav-item"
								to={{ pathname: WEB_REPORTS_URL }}
								target="_blank"
							>
								<FormattedMessage id="navigation.orderStatus" />
							</Link>
						)}
						{authorize(
							['GetSalesReport'],
							<Link
								className="MainNav-item"
								to={{ pathname: SALES_REPORTS_URL }}
								target="_blank"
							>
								<FormattedMessage id="navigation.salesReports" />
							</Link>
						)}
						<NavLink
							className="MainNav-item"
							to="/help"
							exact
							activeClassName="active"
						>
							<FormattedMessage id="navigation.help" />
						</NavLink>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/MainNav/index.js